'use client';

import { Box, PulseRadio, Typography, Input } from 'src/components';
import { SavedType } from 'src/context/reducers';
import { useEncounters } from 'src/context/providers/EncountersProvider';
import { EncountersActionTypes } from 'src/context/reducers/encountersReducer';

type VolumeTypeProps = {
  showVolumeTypes?: boolean;
};

const SaveVolumeType: React.FC<VolumeTypeProps> = ({
  showVolumeTypes,
}: VolumeTypeProps) => {
  const { state, dispatch } = useEncounters();

  // Handler for radio button changes
  const handleTypeChange = (type: SavedType) => {
    dispatch({
      type: EncountersActionTypes.SET_SELECTED_TYPE,
      payload: { selectedType: type },
    });
  };

  // Handler for input changes
  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: EncountersActionTypes.SET_NEW_COHORT_NAME,
      payload: { newCohortName: event.target.value },
    });
  };

  return (
    <Box className="w-full bg-white border-t border-neutral-300">
      <Box className="flex flex-col gap-4 p-6 border-b border-neutral-300">
        <Box className="self-stretch flex flex-col justify-start items-start gap-2">
          <Typography className="justify-start text-black text-sm font-semibold font-['Inter'] leading-tight">
            Volume Name
          </Typography>
          <Input
            data-testid="volume-name-input"
            variant="outlined"
            size="md"
            fullWidth
            placeholder="Type a name..."
            className="rounded-full border-neutral-300 focus-within:border-sky-600 focus-within:border-1 focus-within:shadow-[0px_0px_2px_2px_theme(colors.sky.100)]"
            value={state.newCohortName}
            onChange={handleNameChange}
          />
        </Box>

        {showVolumeTypes && (
          <Box className="inline-flex justify-start items-start gap-4">
            <PulseRadio
              data-testid="personal-radio"
              variant="solid"
              checked={state.selectedType === SavedType.PERSONAL}
              onChange={() => handleTypeChange(SavedType.PERSONAL)}
              className="flex justify-start items-center gap-2"
              label="Personal"
            />
            <PulseRadio
              data-testid="company-radio"
              variant="solid"
              checked={state.selectedType === SavedType.COMPANY}
              onChange={() => handleTypeChange(SavedType.COMPANY)}
              className="flex justify-start items-center gap-2"
              label="Company"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SaveVolumeType;
